import { IssueConfigurationSettings } from '../OptionsPage/components/IssueConfigurationSettings';
import { SettingsShell } from './components/SettingsShell';
import { SettingsContentHeader } from './components/SettingsContentHeader';

export const IssueConfigurationPage = () => {
  return (
    <SettingsShell activeTabPath="issue-configuration" breadcrumbLabel="Issue Configuration">
      <SettingsContentHeader
        title="Issue Configuration"
        subtitle="Configure issue due-date appearance, criticality levels and issue notifications."
      />
      <IssueConfigurationSettings />
    </SettingsShell>
  );
};
